import { Chip } from "@mui/material";
import React, { memo } from "react";

interface FolderChipProps {
    folderName: string;
    onDelete?: () => void;
}

const FolderChip = memo((props: FolderChipProps) => {
    const { folderName, onDelete } = props;
    return <Chip label={folderName} onDelete={onDelete} />;
});

export default FolderChip;
